import { Component, Input } from '@angular/core';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { appConfig } from '@app/app.config';
import { CandidateAdapter } from '@shared';
import { TasksEntityType } from 'mojo-tasks';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { hasAnonymization } from '@collections/users';

@Component({
  selector: 'mojo-tasks-container',
  templateUrl: './tasks.container.html',
})
export class TasksContainerComponent {
  @Input() entityType: TasksEntityType;
  @Input() entityId: number;
  @Input() sideDrawerConfiguration = false;
  @Input() isExpandible = false;
  @Input() showLine = true;
  @Input() width;
  @Input() candidate: CandidateAdapter;
  @Input() entityTitle: string;
  @Input() fromTalentPool = false;

  tasksPrivilege = appConfig.privileges.tasks.view;
  tasksExtension = AppFeatureExtensions.TASKS;
  hasAnonymization$: Observable<boolean> = this.store.select(hasAnonymization);
  constructor(private store: Store<{}>) {}
}
